var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3536 24.2275C15.5936 24.9175 14.4236 24.9175 13.6636 24.2175L13.5536 24.1175C8.30357 19.3675 4.87357 16.2575 5.00357 12.3775C5.06357 10.6775 5.93357 9.04746 7.34357 8.08746C9.98357 6.28746 13.2436 7.12746 15.0036 9.18746C16.7636 7.12746 20.0236 6.27746 22.6636 8.08746C24.0736 9.04746 24.9436 10.6775 25.0036 12.3775C25.1436 16.2575 21.7036 19.3675 16.4536 24.1375L16.3536 24.2275Z",
    fill: "#CC0056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritePink);
export default __webpack_public_path__ + "static/media/favorite_pink.4f33074de052e7f1be15fbaffe2e5ecd.svg";
export { ForwardRef as ReactComponent };